
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class StatGraph extends Vue {
  @Prop({ default: () => [] })
  values!: number[];

  @Prop({ default: () => [] })
  labels!: string[];

  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: "Title" })
  title!: string;

  get valuesIfNotLoading() {
    if (this.loading) return [];
    return this.values;
  }

  labelFilter(label: any) {
    return /^[0-9]{2}:00$/.test(label.value) ? label.value : "";
  }
}
